<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showBlog") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: var(--main_theme_clr)">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image -->
          <!-- <div class="preview-container text-center my-3">
              <img
                v-if="data.image.path"
                col="12"
                :src="data.image.path"
                :alt="$t('PLACEHOLDERS.section_image')"
              />
            </div> -->
          <!-- End:: Image -->

          <!-- Start:: Country Select -->
          <base-select-input
            col="12"
            :optionsList="countriesList"
            :placeholder="$t('PLACEHOLDERS.country')"
            v-model="data.country_id"
            disabled
          />
          <!-- End:: Country Select -->
          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.titleAr')"
            v-model.trim="data.name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.titleEn')"
            v-model.trim="data.nameEn"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descAr')"
            v-model.trim="data.descProd"
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descEn')"
            v-model.trim="data.descProdEn"
            disabled
          />
          <!-- End:: Name Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ShowBlog",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      // Start:: Data Collection To Send
      data: {
        // image: {
        //   path: null,
        //   file: null,
        // },
        name: null,
        nameEn: null,
        descProd: null,
        descProdEn: null,
        active: null,
        country_id: null,
      },
      countriesList: [],
      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    // start show data
    async showRoadRule() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `road-rules/${this.$route.params.id}`,
        });

        const rule = res.data.data.RoadRule;

        // this.data.image.path = rule.image;
        this.data.name = rule.title_ar;
        this.data.nameEn = rule.title_en;
        this.data.descProd = rule.description_ar;
        this.data.descProdEn = rule.description_en;
        this.data.active = rule.is_active;
        this.data.country_id = rule.country;
      } catch (error) {
        this.$message.error(
          error.response?.data?.message || "Error fetching road rule"
        );
      }
    },
    // end show data

    async getCountries() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "countries",
          params: {
            page: 0,
            limit: 0,
          },
        });
        this.countriesList = res.data.data.data;
      } catch (error) {
        this.$message.error(
          error.response?.data?.message || "Error fetching countries"
        );
      }
    },
  },

  created() {
    // Start:: Fire Methods
    this.showRoadRule();
    this.getCountries();
    // End:: Fire Methods
  },
};
</script>
